import { getApiBaseUrlSync } from '@/services/configService'

/** MinIO / 对象存储直链：浏览器可直接加载，无需 JWT */
export function isPublicObjectStorageUrl(url) {
  if (!url || typeof url !== 'string' || !url.startsWith('http')) {
    return false
  }
  try {
    const { hostname } = new URL(url)
    return hostname.includes('objectstorage') || hostname.includes('sealos.run')
  } catch {
    return false
  }
}

/** 将完整 API URL 转为 apiRequest 可用的相对路径 */
export function toApiRelativePath(url) {
  if (!url) return ''
  if (url.startsWith('/')) return url
  const apiBase = getApiBaseUrlSync()
  if (url.startsWith(apiBase)) {
    const path = url.slice(apiBase.length)
    return path.startsWith('/') ? path : `/${path}`
  }
  try {
    const parsed = new URL(url)
    return `${parsed.pathname}${parsed.search}`
  } catch {
    return url
  }
}
